import { Suspense } from 'react';
import { Header, Footer } from './components/layout';
import { Hero, About, Skills, Certifications, Projects, Contact } from './components/sections';
import { ScanlineOverlay } from './components/effects';

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-cyber-bg flex items-center justify-center">
      <div className="text-center">
        <div className="text-4xl font-cyber text-cyber-green animate-pulse mb-4">
          Loading<span className="animate-blink">_</span>
        </div>
        <div className="text-cyber-muted font-mono text-sm">
          Initializing system...
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <div className="relative min-h-screen bg-cyber-bg bg-grid">
        <ScanlineOverlay />
        <Header />

        <main>
          <Hero />
          <About />
          <Skills />
          <Certifications />
          <Projects />
          <Contact />
        </main>

        <Footer />
      </div>
    </Suspense>
  );
}

export default App;
